module.exports = __webpack_public_path__ + "img/calendar_event_white.9897d45d.svg";